module.exports = __webpack_public_path__ + "static/media/UpArrow.54fadb54.svg";